import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails";
import type { SlideImage } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import {
  IPictureProps
} from "../../redux/JamHawInterface"

// import type {
//   Slide,
//   SlideImage,
//   //SlideVideo,
// } from "yet-another-react-lightbox";


export type GalleryItem =
  | {
      type: "image";
      src: string;
      width?: number;
      height?: number;
    }
  | {
      type: "video";
      src: string;
      poster?: string;
    };

interface Props 
{
  items: GalleryItem[];
}

// const slides: SlideImage[] = [
//   {
//     src: "https://jamhaw.com/images/gallery/Gallery2018/IMG_001.jpg",
//     alt: "Image 1",
//   },
//   {
//     src: "https://jamhaw.com/images/gallery/Gallery2018/IMG_002.jpg",
//     alt: "Image 2",
//   },
//   {
//     src: "https://jamhaw.com/images/gallery/Gallery2018/IMG_003.jpg",
//     alt: "Image 3",
//   },
// ];

//export default function GalleryLightbox({ items }: Props) {
export default function GalleryLightbox(_props:IPictureProps) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);


  console.log("HERE!", _props.slides);
  return (
    <>
      <div style={{ padding: 20 }}>
        <div style={{ display: "-webkit-box", gap: 10 }}>
          {_props.slides.map((slide, i) => (
            <img
              key={i}
              src={slide.src}
              alt={slide.alt}
              style={{ width: 50, cursor: "pointer" }}
              onClick={() => {
                setIndex(i);
                setOpen(true);
              }}
            />
          ))}
        </div>

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={_props.slides}
          index={index}
        />
      </div>
    </>
  );
}
